import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';

/**
 * PermissionRoute - A component that protects routes based on specific permissions
 * @param {React.ReactNode} children - The component to render if permission is granted
 * @param {string} requiredPermission - The permission required to access this route
 * @param {string} redirectTo - Where to redirect if permission is denied (default: '/admin/dashboard')
 */
const PermissionRoute = ({ children, requiredPermission, redirectTo = '/admin/dashboard' }) => {
  const { can } = usePermissions();
  const location = useLocation();

  // Check if user has the required permission
  if (!can(requiredPermission)) {
    // Redirect to specified location if permission is denied
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // User has permission, render the component
  return children;
};

export default PermissionRoute;

